import type { SiteLink } from "~/constants/socials";

import type { FooterSection, IFooterCmsLink } from "../types";

const byPosition = (a: IFooterCmsLink, b: IFooterCmsLink) => {
  if (a.order === b.order) {
    return a.link.label.localeCompare(b.link.label);
  }

  if (a.order === null) {
    return 1;
  }

  if (b.order === null) {
    return -1;
  }

  return a.order - b.order;
};

export const buildFooterColumnLinks = (
  section: FooterSection,
  staticLinks: SiteLink[],
  cmsLinks: IFooterCmsLink[]
): SiteLink[] => {
  const sectionLinks = cmsLinks
    .filter((item) => item.section === section)
    .sort(byPosition);
  const cmsUrls = new Set(sectionLinks.map((item) => item.link.to));
  const links = staticLinks.filter((link) => !cmsUrls.has(link.to));

  sectionLinks.forEach(({ order, link }) => {
    const index =
      order === null
        ? links.length
        : Math.min(Math.max(order - 1, 0), links.length);

    links.splice(index, 0, link);
  });

  return links;
};
